<img
  class="cursor"
  [src]="mobileView ? logoMobile : logo"
  (click)="gotolink()"
  [ngClass]="class == 'store' ? 'store' : mobileView ? 'mobile' : 'desktop'"
/>
